module.exports = __webpack_public_path__ + "static/sebastien-7ff6dd04691a8cc1f84688f4ebd0cf18.png";